import type { CSSObject } from "@emotion/serialize";

import { clearLinkColor } from "./clearLinkColor";

export const clearLinkDecoration = (color = "inherit", symbolColor?: string): CSSObject => {
  const symColor = symbolColor || color;
  const linkColor = clearLinkColor(color, symColor);

  return {
    ...linkColor,
    ":hover": {
      ...linkColor[":hover"],
      textDecoration: "none",
    },
  };
};
